var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 51,
    viewBox: "0 0 120 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#fff;}.b{fill:#fff;stroke:#000;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-874 -6869.25)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(874 6869.25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 60,
    cy: 25.5,
    rx: 60,
    ry: 25.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 60,
    cy: 25.5,
    rx: 59.5,
    ry: 25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(920.429 6881.179)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.571,0C9.888,0,9.425.017,7.978.081a10,10,0,0,0-3.3.631,6.645,6.645,0,0,0-2.4,1.566,6.662,6.662,0,0,0-1.566,2.4A9.941,9.941,0,0,0,.081,7.973C.017,9.424,0,9.885,0,13.573s.017,4.146.081,5.593A10,10,0,0,0,.712,22.46,6.948,6.948,0,0,0,4.68,26.43a9.964,9.964,0,0,0,3.294.631c1.449.064,1.91.081,5.6.081s4.146-.017,5.595-.081a10.018,10.018,0,0,0,3.3-.631,6.948,6.948,0,0,0,3.968-3.97,10.042,10.042,0,0,0,.631-3.294c.064-1.447.081-1.908.081-5.595s-.017-4.148-.081-5.6a10.031,10.031,0,0,0-.631-3.293,6.66,6.66,0,0,0-1.566-2.4A6.635,6.635,0,0,0,22.46.712a9.984,9.984,0,0,0-3.3-.631C17.716.017,17.256,0,13.568,0h.005ZM12.355,2.446h1.218c3.624,0,4.053.012,5.483.078a7.521,7.521,0,0,1,2.521.467,4.211,4.211,0,0,1,1.561,1.016,4.193,4.193,0,0,1,1.014,1.561,7.454,7.454,0,0,1,.467,2.519c.066,1.43.08,1.859.08,5.481s-.014,4.053-.08,5.483a7.508,7.508,0,0,1-.467,2.519,4.5,4.5,0,0,1-2.577,2.573,7.466,7.466,0,0,1-2.519.468c-1.43.064-1.859.08-5.483.08s-4.054-.015-5.484-.08a7.5,7.5,0,0,1-2.519-.468,4.2,4.2,0,0,1-1.561-1.014,4.207,4.207,0,0,1-1.018-1.561,7.5,7.5,0,0,1-.467-2.519c-.064-1.43-.078-1.859-.078-5.484s.014-4.051.078-5.481a7.509,7.509,0,0,1,.468-2.521A4.211,4.211,0,0,1,4.009,4,4.193,4.193,0,0,1,5.569,2.987a7.5,7.5,0,0,1,2.519-.468c1.252-.058,1.737-.075,4.266-.076v0ZM20.817,4.7a1.629,1.629,0,1,0,1.629,1.629A1.629,1.629,0,0,0,20.817,4.7ZM13.573,6.6a6.97,6.97,0,1,0,6.971,6.97A6.969,6.969,0,0,0,13.573,6.6Zm0,2.445a4.524,4.524,0,1,1-4.524,4.524A4.524,4.524,0,0,1,13.573,9.047Z",
    transform: "translate(0 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8dd362069d2728e125aa10984abd4556.svg";
export { ForwardRef as ReactComponent };